import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useP2PStore from '../stores/p2pStore';

const Toast = ({ message }) => (
  <div className="fixed bottom-6 right-6 bg-gray-800 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-fade">
    {message}
  </div>
);

const RoomCreated = () => {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const [showToast, setShowToast] = useState(false);
  const roomUrl = `https://rps-game.tools.camp/guest/${roomId}`;
  // const roomUrl = `http://localhost:3000/guest/${roomId}`;
  const { initialize, connect } = useP2PStore();

  useEffect(() => {
    initialize(
      "https://b7c5eyyip5qvb5uyud2w3jowce0jjijc.lambda-url.ap-northeast-2.on.aws/",
      "handsomecoder58!"  
    );
    connect(roomId);
  }, [roomId, initialize, connect]);

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(roomUrl);
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 3000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  const handleEnterRoom = () => {
    navigate(`/host/${roomId}`);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 px-4">
      <div className="bg-white/10 backdrop-blur-lg p-4 sm:p-8 rounded-2xl shadow-2xl w-full max-w-2xl border border-white/20 relative">
        <button
          onClick={() => navigate('/')}
          className="absolute top-4 right-4 px-3 py-1 sm:px-4 sm:py-2 bg-white/20 hover:bg-white/30 text-white rounded-xl transition-all duration-300 text-sm sm:text-base"
        >
          Home
        </button>
        <h1 className="text-2xl sm:text-4xl font-bold mb-6 sm:mb-8 text-center text-white">
          Room Created!
        </h1>
        <div className="mb-6">
          <p className="text-xs sm:text-sm text-white/80 mb-2">Share this room URL with your opponent:</p>
          <div className="flex flex-col sm:flex-row gap-2">
            <input
              type="text"
              value={roomUrl}
              readOnly
              className="w-full p-3 sm:p-4 rounded-xl bg-white/10 text-white border border-white/30 focus:outline-none text-sm sm:text-base"
            />
            <button
              onClick={handleCopyUrl}
              className="px-4 py-2 sm:px-6 bg-white/20 hover:bg-white/30 text-white rounded-xl 
                       transition-all duration-300 ease-in-out transform hover:scale-105
                       border border-white/30 text-sm sm:text-base"
            >
              Copy
            </button>
          </div>
        </div>
        <button
          onClick={handleEnterRoom}
          className="w-full py-3 sm:py-4 bg-white/20 hover:bg-white/30 text-white text-base sm:text-lg font-semibold rounded-xl 
                   transition-all duration-300 ease-in-out transform hover:scale-105 
                   shadow-lg hover:shadow-xl border border-white/30"
        >
          Enter Room
        </button>
      </div>
      {showToast && <Toast message="URL copied to clipboard!" />}
    </div>
  );
};

export default RoomCreated;